// extracted by mini-css-extract-plugin
module.exports = {"textAreaRoot":"styles_textAreaRoot__3ZRO4","confirmationHeader":"styles_confirmationHeader__E0hQl"};